import * as ng from 'angular';

import { ApiHelperService } from '../../shared';

const keyMaxLength = 50;

export class SurveyItemsApiService {

   static $inject = ['apiHelper', 'fileDownload'];

   constructor(
      private apiHelper:ApiHelperService,
      private fileDownload
   ) { }

   list(brandId:number) {
      return this.apiHelper.get(`surveyitems?brandId=${brandId}`);
   }

   get(id) {
      return this.apiHelper.get(`surveyitems/${id}`);
   }

   create(surveyItem) {
      return this.apiHelper.post('surveyitems', surveyItem);
   }

   update(surveyItem) {
      return this.apiHelper.post(`surveyitems/${surveyItem.id}`, surveyItem);
   }

   del(id:number) {
      return this.apiHelper.del(`surveyitems/${id}`);
   }

   addChoice(surveyItemChoice) {
      let uri = `surveyitems/${surveyItemChoice.surveyItemId}/choice`;
      return this.apiHelper.post(uri, surveyItemChoice);
   }

   updateChoice(surveyItemChoice) {
      let uri = `surveyitems/${surveyItemChoice.surveyItemId}/choice/${surveyItemChoice.id}`;
      return this.apiHelper.post(uri, surveyItemChoice);
   }

   removeChoice(surveyItemChoice) {
      let uri = `surveyitems/${surveyItemChoice.surveyItemId}/choice/${surveyItemChoice.id}`;
      return this.apiHelper.del(uri);
   }

   keyFromLabel(label:string) {
      if (label) {
         return label.replace(/[~`!#\$%\^&\*\(\)_\-\+\=\\\|\{\}\[\]\;\:\'\"<\>\,\.\/\?@\-]*/g, '')
                     .trim()
                     .replace(/\s+/g, '-')
                     .toLowerCase()
                     .substring(0, keyMaxLength)//truncate key to 50 chars
                     .replace(/-$/, '');//if last char is '-' then remove
      } else {
         return null;
      }
   }

   uniqueKey(key:string, existingKeys:string[]) {
      if (!key) {
         return null;
      }

      var originalKey = key;
      var keyId = 1;

      while (existingKeys.indexOf(key) >= 0) {
         key = (keyId++) + originalKey;
         if (key.length > keyMaxLength) {
            key = key.substring(0, keyMaxLength)
                     .replace(/-$/, '');//if last char is '-' then remove
         }
      }

      return key;
   }

   export(brandId:number) {
      let url = this.apiHelper.getApiUrl(`surveyItems/export/${brandId}`);
      return new this.fileDownload(url, {download: true}).get();
   }

   import(brandId:number, file, force) {
      var fd = new FormData();
      fd.append('file', file);
      var url = 'surveyItems/import/' + brandId;
      if (force) {
         url = url + '?force=true';
      }
      return this.apiHelper.post(url, fd);
   }

   validateXmlFile(brandId:number, file:File) {
      let formData = new FormData();
      formData.append('file', file, file.name);

      let url = `surveyItems/validate/${brandId}`;

      return this.apiHelper.post<XmlValidationResult[]>(url, formData);
   }
}

export interface XmlValidationResult {
   severity:'Error'|'Warn';
   lineNumber:number;
   message:string;
}

ng.module('e360')
   .service('surveyItemsApi', SurveyItemsApiService);
